import { render } from "./NewAssessmentModal.vue?vue&type=template&id=797d490b&scoped=true"
import script from "./NewAssessmentModal.vue?vue&type=script&lang=js"
export * from "./NewAssessmentModal.vue?vue&type=script&lang=js"

import "./NewAssessmentModal.vue?vue&type=style&index=0&id=797d490b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797d490b"]])

export default __exports__